import background1 from './images/nutstore_more_1_pic.svg'
import background2 from './images/nutstore_more_2_pic.svg'
import listaryBackground1 from './images/listary_more1_pic.svg'
import listaryBackground2 from './images/listary_more2_pic.svg'
import bannerEn from './images/home_banner_en.svg'
import bannerZh from './images/home_banner.svg'
import bannerDisplay from './images/home_banner_display.svg'
import bannerDisplayen from './images/home_banner_display_en.svg'

import iconInsurance from './images/icon_file_keyboard.svg'
import iconSync from './images/icon_file_insurance.svg'
import iconSafe from './images/icon_offline_inspiration.svg'
import iconEasy from './images/icon_easy_to_use.svg'

import appinn from './images/appinn_logo.svg'
import it from './images/zhihu_logo.svg'
import minority from './images/minority_logo.svg'

export const getConstants = prop => Constants[prop]

const env = Constants.LOCAL_LANGUAGE
const pageName = 'listary'

export const appBanner = {
	pageName,
	bannerEn,
	bannerZh,
	bannerDisplay: env === 'zh' ? bannerDisplay : bannerDisplayen,
}

export const appBenifit = {
	title: getConstants('LISTARY_LANDING_BENIFIT_TITLE'),
	subTitle: getConstants('LISTARY_LANDING_BENIFIT_SUBTITLE'),
	list: [
		{
			title: getConstants('LISTARY_LANDING_BENIFIT_BLOCK1_TITLE'),
			before: getConstants('LISTARY_LANDING_BENIFIT_BLOCK1_BEFORE'),
			after: getConstants('LISTARY_LANDING_BENIFIT_BLOCK1_AFTER'),
			icon: iconInsurance,
		},
		{
			before: getConstants('LISTARY_LANDING_BENIFIT_BLOCK2_BEFORE'),
			after: getConstants('LISTARY_LANDING_BENIFIT_BLOCK2_AFTER'),
			title: getConstants('LISTARY_LANDING_BENIFIT_BLOCK2_TITLE'),
			icon: iconSafe,
		},
		{
			title: getConstants('LISTARY_LANDING_BENIFIT_BLOCK3_TITLE'),
			before: getConstants('LISTARY_LANDING_BENIFIT_BLOCK3_BEFORE'),
			after: getConstants('LISTARY_LANDING_BENIFIT_BLOCK3_AFTER'),
			icon: iconSync,
		},
		{
			title: getConstants('LISTARY_LANDING_BENIFIT_BLOCK4_TITLE'),
			before: getConstants('LISTARY_LANDING_BENIFIT_BLOCK4_BEFORE'),
			after: getConstants('LISTARY_LANDING_BENIFIT_BLOCK4_AFTER'),
			icon: iconEasy,
		},
	],
}

export const appSale = {
	advanced: {
		title: getConstants('LISTARY_LANDING_SALE_ADVANCE_TITLE'),
		subTitle: getConstants('LISTARY_LANDING_SALE_ADVANCE_SUBTITLE'),
		originPrice: getConstants('LISTARY_LANDING_SALE_ADVANCE_ORIGIN_PRICE'),
		edition: getConstants('BOXCRYPTOR_LANDING_SALE_ADVANCE_EDITION'),
		saleText1: getConstants('BOXCRYPTOR_LANDING_SALE_ADVANCE_TEXT1'),
		saleText2: getConstants('BOXCRYPTOR_LANDING_SALE_ADVANCE_TEXT2'),
		saleText3: getConstants('BOXCRYPTOR_LANDING_SALE_ADVANCE_TEXT3'),
		saleTip: getConstants('BOXCRYPTOR_LANDING_SALE_TRAFFIC_TIP'),
		update: getConstants('BOXCRYPTOR_LANDING_SALE_UPDATE'),
	},
	pro: {
		title: getConstants('LISTARY_LANDING_SALE_PRO_TITLE'),
		subTitle: getConstants('LISTARY_LANDING_SALE_PRO_SUBTITLE'),
		originPrice: getConstants('LISTARY_LANDING_SALE_PRO_ORIGIN_PRICE'),
		edition: getConstants('BOXCRYPTOR_LANDING_SALE_PRO_EDITION'),
		saleText1: getConstants('BOXCRYPTOR_LANDING_SALE_PRO_TEXT1'),
		saleText2: getConstants('BOXCRYPTOR_LANDING_SALE_PRO_TEXT2'),
		saleText3: getConstants('BOXCRYPTOR_LANDING_SALE_PRO_TEXT3'),
		saleTip: getConstants('BOXCRYPTOR_LANDING_SALE_TRAFFIC_TIP'),
		update: getConstants('BOXCRYPTOR_LANDING_SALE_UPDATE'),
	},
	extra: {
		title: getConstants('LISTARY_LANDING_SALE_LICENSE'),
		list: [
			getConstants('LISTARY_LANDING_SALE_LICENSE_TEXT1'),
			getConstants('LISTARY_LANDING_SALE_LICENSE_TEXT2'),
		],
	},
}

export const paidModal = {
	name: getConstants('LISTARY_LANDING_SALE_PAID_NAME'),
	content: getConstants('LISTARY_LANDING_SALE_PAID_CONTENT'),
	tip: getConstants('LISTARY_LANDING_SALE_PAID_TIP'),
	price: getConstants('LISTARY_LANDING_SALE_PAID_PRICE'),
	plan: getConstants('LISTARY_LANDING_SALE_PLAN'),
	pro: {
		title: getConstants('LISTARY_LANDING_SALE_PRO_TITLE'),
		originPrice: '¥ 556',
		planVersion: getConstants('PRICING_NEW_EAGLE_SELECT_VERSION_PRO'),
		planOrigin: getConstants('PRICING_NEW_EAGLE_SELECT_ORIGIN_PRICE_360'),
	},
	advance: {
		title: getConstants('LISTARY_LANDING_SALE_ADVANCE_TITLE'),
		originPrice: '¥ 916',
		planVersion: getConstants('PRICING_NEW_EAGLE_SELECT_VERSION_ADVANCE'),
		planOrigin: getConstants('PRICING_NEW_EAGLE_SELECT_ORIGIN_PRICE_720'),
	},
}

export const appRecommend = {
	title: getConstants('LISTARY_LANDING_RECOMMEND_TITLE'),
	subTitle: getConstants('LISTARY_LANDING_RECOMMEND_SUBTITLE'),
	blocks: [
		{
			text: getConstants('LISTARY_LANDING_RECOMMEND_BLOCK1_TEXT'),
			name: getConstants('LISTARY_LANDING_RECOMMEND_BLOCK1_USER'),
			logo: env === 'cn' ? it : null,
		},
		{
			text: getConstants('LISTARY_LANDING_RECOMMEND_BLOCK2_TEXT'),
			name: getConstants('LISTARY_LANDING_RECOMMEND_BLOCK2_USER'),
			logo: env === 'cn' ? appinn : null,
		},
		{
			text: getConstants('LISTARY_LANDING_RECOMMEND_BLOCK3_TEXT'),
			name: getConstants('LISTARY_LANDING_RECOMMEND_BLOCK3_USER'),
			logo: env === 'cn' ? minority : null,
		},
	],
}

export const appFaq = [1, 2, 3, 4, 5, 6, 7, 8].map(num => ({
	title: getConstants(`LISTARY_LANDING_FAQ_DETAIL_TITLE${num}`),
	text: getConstants(`LISTARY_LANDING_FAQ_DETAIL_TEXT${num}`),
}))

export const appMore = [
	{
		title: getConstants('EAGLE_LANDING_MORE_NUTSTORE_TITLE'),
		subTitle: getConstants('EAGLE_LANDING_MORE_NUTSTORE_SUBTITLE'),
		src1: background1,
		src2: background2,
		texts1: [
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT1'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT2'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT3'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT4'),
		],
		texts2: [
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT5'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT6'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT7'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT8'),
			getConstants('EAGLE_LANDING_MORE_NUTSTORE_TEXT9'),
		],
	},
	{
		class: 'listary-landing-more',
		title: getConstants('LISTARY_LANDING_MORE_NUTSTORE_TITLE'),
		subTitle: getConstants('LISTARY_LANDING_MORE_NUTSTORE_SUBTITLE'),
		src1: listaryBackground1,
		src2: listaryBackground2,
		texts1: [
			getConstants('LISTARY_LANDING_MORE_NUTSTORE_TEXT1'),
			getConstants('LISTARY_LANDING_MORE_NUTSTORE_TEXT2'),
			getConstants('LISTARY_LANDING_MORE_NUTSTORE_TEXT3'),
			getConstants('LISTARY_LANDING_MORE_NUTSTORE_TEXT4'),
		],
		texts2: [
			getConstants('LISTARY_LANDING_MORE_NUTSTORE_TEXT5'),
			getConstants('LISTARY_LANDING_MORE_NUTSTORE_TEXT6'),
			getConstants('LISTARY_LANDING_MORE_NUTSTORE_TEXT7'),
			getConstants('LISTARY_LANDING_MORE_NUTSTORE_TEXT8'),
			getConstants('LISTARY_LANDING_MORE_NUTSTORE_TEXT9'),
		],
	},
]

export const appHeader = {
	pageName,
}
